import React, { useState, useEffect, useContext } from 'react'
import {
  makeStyles,
  Box,
  Typography,
  Button,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import CustomizedProgressBars from './ProgressData'
import { ErrorOutline } from '@material-ui/icons'
import { AuthContext } from 'src/context/Auth'
import { useHistory } from 'react-router-dom'
import ButtonCircularProgress from 'src/component/ButtonCircularProgress'
import axios from 'axios'
import ApiConfig from 'src/APIconfig/ApiConfig'
import Slider from 'react-slick'
import NoDataFound from 'src/DataNotFound'
import { sortAddress } from 'src/utils'
import { useLocation } from 'react-router-dom'
import Tooltip from '@material-ui/core/Tooltip'
const useStyles = makeStyles((theme) => ({
  mainbox: {
    paddingBottom: '50px',
    backgroundColor: theme.palette.background.dark2,
    // backgroundColor: 'hsl(216deg 33% 97%)',
    [theme.breakpoints.down('xs')]: {
      paddingBottom: '20px',
    },
  },
  search: {
    border: '1px solid #dcdcdc',
    padding: '5px',
    height: '50px',
    display: 'flex',
    background: theme.palette.background.dark,
    justifyContent: 'space-between',
    paddingLeft: '15px',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '10px',
    },
    '& input': {
      width: '80%',
      background: theme.palette.background.dark,
      border: 'none',
      outline: 'none',
      fontSize: '14px',
      paddingRight: '17px',
      color: theme.palette.text.black,
      [theme.breakpoints.down('xs')]: {
        fontSize: '12px',
      },
    },
    '& Button': {
      margin: '0',
    },
  },
  newbox: {
    maxWidth: '100%',
    height: '50px',
    backgroundColor: 'hsl(203deg 100% 93%)',
    width: '50%',
    display: 'flex',
    justifyContent: 'center',
    border: '0.25px dashed #F1F2F3',
    '& img': {
      margin: '10px',
      maxWidth: '100%',
    },
    '& Button': {
      backgroundColor: '#ffffff',
      margin: '10px',
      maxWidth: '100%',
    },
    '& input': {
      border: 'none',
      width: '60%',
      backgroundColor: 'hsl(203deg 100% 93%)',
      outline: 'none',
    },
  },

  sponsored: {
    border: '0.25px dashed #dcdcdc',
    backgroundColor: '#dbf1ff',
    borderTop: 'none',
    display: 'flex',
    padding: '5px 15px',
    justifyContent: 'space-between',
    flexDirection: 'column',
    maxHeight: '150px',
    overflowY: 'auto',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
  },
  button: {
    display: ' flex',
    alignItems: 'center',
    padding: ' 0 5px',
    marginRight: '10px',
    backgroundColor: '#f0f9f6',
    color: '#595959',
    '& span': {
      fontSize: '10px !important',
    },
    '& svg': {
      fontSize: '17px',
    },
    '&:hover': {
      backgroundColor: '#f0f9f6',
    },
  },
  flexbox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px',
    '& p': {
      fontSize: '12px',
      color: theme.palette.text.black,
    },
    '& h6': {
      fontSize: '12px',
    },
  },
  Add: {
    // display: 'flex',
    '& figure': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '150px',
      // width: '100%',
      // width: '970px',
      height: '120px',
      overflow: 'hidden',
      // borderRadius: '15px',
      '& img': {
        maxHeight: '100%',
        maxWidth: '100%',
        height: 'auto',
        width: 'auto',
        display: 'block',
      },
    },
  },
  noDataFound: {
    '& h4': {
      fontSize: '10px',
      color: '#000',
    },
  },
  // slider2:{
  //   display:"flex",
  //   justifyContent:"center"
  // }
  // Add: {
  //   "& img": {
  //     width: "100%",
  //     maxHeight: "150px",
  //   },
  // },
  suggestionBox: {
    '& h4': {
      margin: '10px 0px',
      fontSize: '15px',
    },
  },
  hoverSponsor: {
    '& :hover': {
      backgroundColor: '#fff',
    },
  },
  tokenSuggestionBox: {
    display: 'flex',
    alignItems: 'center',
    '@media(max-width:768px)': {
      display: 'block',
    },
  },
}))

function Head({ auth }) {
  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    autoplay: true,
    arrows: false,
  }
  const classes = useStyles()
  const history = useHistory()
  // const location = useLocation()
  // const auth = useContext(AuthContext)
  const [adsView, setadsView] = useState([])
  const [isSearchLoading, setIsSearchLoading] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [openNetworkModal, setOpenNetworkModal] = useState(false)
  const [adView, setAdView] = useState(false)
  const [suggestionData, setSuggestionData] = useState([])
  const [ip, setIP] = useState('')
  const [open, setOpen] = useState(false)
  const [networkName, setNetworkName] = useState('')
  const [openAdvDetails, setOpenAdvDetails] = useState(false)
  useEffect(() => {
    setIsSearchLoading(auth?.isLoadingSearchedData)
    if (auth?.isLoadingSearchedData === 100) {
      history.push('/tokens')
      auth.setSearchToken('')
      auth.setIsLoadingSearchedData(0)
    }
  }, [auth?.isLoadingSearchedData])

  function getRandomInt(max) {
    return Math.floor(Math.random() * max)
  }
  useEffect(() => {
    if (auth?.advertismnet) {
      const filterFunForTop = auth?.advertismnet.filter((data) => {
        return data?.adType === 'Landing'
      })
      const id = getRandomInt(filterFunForTop.length)
      setadsView(filterFunForTop[id])
    }
    setIsLoading(auth?.isLoadingAds)
  }, [auth?.advertismnet])

  useEffect(() => {
    if (auth?.networkCount?.length >= 2) {
      setOpenNetworkModal(true)
    } else if (auth?.networkCount?.length === 1) {
      if (auth.bscScanResult !== '') {
        auth.setSearchNetwork('BSC')
        auth.setIsSearchTrue(false)
      } else if (auth.ethScanResult !== '') {
        auth.setSearchNetwork('ETH')
        auth.setIsSearchTrue(false)
        setNetworkName('Ethereum')
      } else if (auth.polygonScanResult !== '') {
        auth.setSearchNetwork('Polygon')
        setNetworkName('Polygon')
        auth.setIsSearchTrue(false)
      }
    }
  }, [
    auth?.networkCount,
    auth.bscScanResult,
    auth.ethScanResult,
    auth.polygonScanResult,
  ])

  const AddsCount = async (id, mode) => {
    try {
      setIsLoading(true)

      const res = await axios({
        method: 'GET',
        url: ApiConfig.viewAdvertisment1,
        params: {
          _id: id,
          ipAddress: ip,
          viewMode: mode,
        },
      })
      if (res.data.responseCode === 200) {
        // setTokenRequest(res.data.result.docs);
        setIsLoading(false)
      }
    } catch (error) {
      console.log('ERROR', error)
      setIsLoading(false)
    }
  }

  const viewSponsorCounthandler = async (sponsorId) => {
    try {
      const res = await axios({
        method: 'GET',
        url: ApiConfig.viewSponsor,
        // headers: {
        //   token: window.sessionStorage.getItem('token'),
        // },
        params: {
          sponsorId: sponsorId,
          ipAddress: ip,
          viewMode: 'Desktop',
        },
      })
    } catch (error) {
      console.log(error)
    }
  }

  const searchSuggestionsHandler = async (searchKey) => {
    try {
      setSuggestionData([])
      const res = await axios({
        method: 'GET',
        url: ApiConfig.suggestion,

        params: {
          name: searchKey,
        },
      })
      if (res.data.responseCode === 200) {
        const filterFun = res?.data?.result?.filter((data) => {
          return data.contractInfo !== undefined
        })
        console.log('resultSuggestions----', filterFun)
        setSuggestionData(filterFun)
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    if (auth?.searchToken !== '') {
      searchSuggestionsHandler(auth?.searchToken)
    }
  }, [auth?.searchToken])
  const getData = async () => {
    const res = await axios.get('https://geolocation-db.com/json/')
    console.log(res.data)
    setIP(res.data.IPv4)
  }
  useEffect(() => {
    //passing getData method to the lifecycle method
    getData()
  }, [])
  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  })
  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 972
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }))
    }

    setResponsiveness()

    window.addEventListener('resize', () => setResponsiveness())
  }, [])
  const something = (event) => {
    if (event.keyCode === 13) {
      if (auth?.searchToken !== '') {
        auth.setIsSearchTrue(true)
      }
    }
  }

  useEffect(() => {
    if (auth.isETHPolygon) {
      setOpen(true)
    } else {
      setOpen(false)
    }
  }, [auth.isETHPolygon])

  return (
    <>
      <Box className={classes.mainbox}>
        <Container maxWidth="lg">
          <Box style={{ paddingTop: '50px' }}>
            {isSearchLoading > 0 && (
              <CustomizedProgressBars isSearchLoading={isSearchLoading} />
            )}

            {isSearchLoading > 0 && isSearchLoading < 100 && (
              <Box className={classes.flexbox}>
                <Typography variant="body2">
                  Getting data from blockchain......
                </Typography>
              </Box>
            )}
            {isSearchLoading === 100 && (
              <Box className={classes.flexbox}>
                <Typography variant="body2">
                  Details has been fetched successfully
                </Typography>
              </Box>
            )}
          </Box>
        </Container>

        <Container maxWidth="sm">
          <Box className={classes.contentbox} mt={5}>
            <Box className={classes.search}>
              <input
                placeholder="Scan by Token Name / Address / Wallet"
                onChange={(e) => auth.setSearchToken(e.target.value)}
                value={auth?.searchToken}
                onKeyDown={(e) => something(e)}
                // onMouseDown={() => setAdView(true)}
                // onMouseOut={() => setAdView(false)}
              />
              <Button
                variant="contained"
                size="large"
                color="primary"
                style={{ backgroundColor: 'rgb(90 134 255)' }}
                disabled={auth?.searchToken === '' || isSearchLoading > 0}
                onClick={() => {
                  // if (window.sessionStorage.getItem('token')) {
                  auth.setIsSearchTrue(true)
                  // auth.setIsLoadingSearchedData(auth?.isLoadingSearchedData + 5)
                  // } else {
                  //   history.push('/tokens-login')
                  // }
                }}
              >
                SCAN
              </Button>
            </Box>
            {auth?.searchToken !== '' ? (
              <Box className={classes.sponsored}>
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    viewSponsorCounthandler(auth?.sponsorData[0]?._id)
                    window.open(`${auth?.sponsorData[0]?.url}`)
                  }}
                >
                  <Box className={classes.flexbox}>
                    <img
                      src={
                        auth?.sponsorData[0]?.logo
                          ? auth?.sponsorData[0]?.logo
                          : 'images/token.png'
                      }
                      alt="Sponsored Image"
                      style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        marginRight: '10px',
                      }}
                    />
                    <Typography variant="h6">
                      {auth?.sponsorData[0]?.description}
                    </Typography>
                  </Box>
                  <Box className={classes.flexbox}>
                    <Button className={classes.button}>SPONSORED</Button>
                    <Box className={classes.button} align="center">
                      <ErrorOutline />
                    </Box>
                  </Box>
                </Box>
                <Box className={classes.suggestionBox}>
                  <Typography variant="h4">Tokens</Typography>
                  {suggestionData &&
                    suggestionData.map((data, i) => {
                      return (
                        <Box
                          className={`${classes.flexbox} ${classes.hoverSponsor}`}
                          style={{
                            // justifyContent: 'flex-start',
                            cursor: 'pointer',
                            // flexDirection: 'column',
                          }}
                          width="100%"
                          onClick={() =>
                            history.push({
                              pathname: '/tokens',
                              search: data.contractAddress,
                              state: { network: data?.contractType },
                            })
                          }
                        >
                          <Box
                            display="flex"
                            // justifyContent="space-between"
                            width="100%"
                            padding="6px"
                            className={classes.tokenSuggestionBox}
                          >
                            <Box display="flex" alignItems="center">
                              <Box>
                                <Typography variant="h6">
                                  {data.contractInfo !== undefined
                                    ? `${data?.contractInfo?.name?.slice(
                                        0,
                                        10,
                                      )} (${data?.contractInfo?.symbol?.slice(
                                        0,
                                        3,
                                      )}) | `
                                    : '--'}{' '}
                                </Typography>
                              </Box>

                              <Box>
                                <Typography variant="h6">
                                  &nbsp;
                                  <span
                                    style={{
                                      fontWeight: '600',
                                      marginRight: '4px',
                                    }}
                                  >
                                    Contract:
                                  </span>
                                  {data?.contractAddress
                                    ? `${sortAddress(data?.contractAddress)} | `
                                    : '0XX000'}
                                </Typography>
                              </Box>
                            </Box>
                            <Box display="flex" alignItems="center">
                              <Box>
                                <Typography variant="h6">
                                  &nbsp;
                                  <span
                                    style={{
                                      fontWeight: '600',
                                      marginRight: '4px',
                                    }}
                                  >
                                    Price:
                                  </span>
                                  {data?.contractInfo?.priceInUSD
                                    ? `${Number(
                                        data?.contractInfo?.priceInUSD,
                                      ).toFixed(2)} |`
                                    : data?.contractInfo?.current_price
                                    ? `${Number(
                                        data?.contractInfo?.current_price,
                                      ).toFixed(2)} |`
                                    : '0'}
                                </Typography>
                              </Box>

                              <Box>
                                <Typography variant="h6">
                                  &nbsp;
                                  <span
                                    style={{
                                      fontWeight: '600',
                                      marginRight: '4px',
                                    }}
                                  >
                                    Score:
                                  </span>
                                  {data?.contractScan
                                    ? ` ${Number(data?.contractScan).toFixed(
                                        2,
                                      )}`
                                    : '0'}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      )
                    })}
                  {suggestionData && suggestionData.length === 0 && (
                    // <NoDataFound />
                    <Box className={classes.noDataFound}>
                      <Typography
                        variant="h4"
                        style={{ color: '#000', fontSize: '12px' }}
                      >
                        No search result found!
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            ) : (
              <Box style={{ height: '45px' }}></Box>
            )}
          </Box>
        </Container>
        <Container className={classes.containersection}>
          {/* <Slider {...settings} style={{ display: 'flex' }}> */}
          <Container>
            <Box className={classes.Add}>
              {!state.mobileView ? (
                <Tooltip
                  open={openAdvDetails}
                  onClose={() => setOpenAdvDetails(false)}
                  onOpen={() => setOpenAdvDetails(true)}
                  title={adsView?.description}
                >
                  <figure>
                    <img
                      src={adsView?.image ? adsView?.image : 'images/add.png'}
                      alt="ADD"
                      onClick={() => {
                        if (adsView?.adURL) {
                          window.open(`${adsView?.adURL}`)
                          AddsCount(adsView?._id, 'Desktop')
                        }
                      }}
                      style={{ width: 'inherit', cursor: 'pointer' }}
                    />
                  </figure>
                </Tooltip>
              ) : (
                <Tooltip
                  open={openAdvDetails}
                  onClose={() => setOpenAdvDetails(false)}
                  onOpen={() => setOpenAdvDetails(true)}
                  title={adsView?.description}
                >
                  <figure>
                    <img
                      src={
                        adsView?.mobileImage
                          ? adsView?.mobileImage
                          : 'images/add.png'
                      }
                      alt="ADD"
                      onClick={() => {
                        if (adsView?.adURL) {
                          window.open(`${adsView?.adURL}`)
                          AddsCount(adsView?._id, 'Mobile')
                        }
                      }}
                      style={{
                        width: '321px',
                        height: '101px',
                        cursor: 'pointer',
                      }}
                    />
                  </figure>
                </Tooltip>
              )}
            </Box>
          </Container>
          {/* </Slider> */}
        </Container>
      </Box>
      <Dialog
        open={openNetworkModal}
        fullWidth
        maxWidth="sm"
        // onClose={() => setOpenNetworkModal(false)}
      >
        <DialogTitle id="alert-dialog-title">{'Select Network'}</DialogTitle>
        <DialogContent>
          {auth?.bscScanResult !== '' && (
            <Button
              fullWidth
              onClick={() => {
                auth.setSearchNetwork('BSC')
                setOpenNetworkModal(false)
                auth.setNetworkcount(0)
              }}
            >
              BSC
            </Button>
          )}
          {auth?.ethScanResult !== '' && (
            <Button
              fullWidth
              onClick={() => {
                auth.setSearchNetwork('ETH')
                setOpenNetworkModal(false)
                auth.setNetworkcount(0)
              }}
            >
              ETH
            </Button>
          )}
          {auth?.polygonScanResult !== '' && (
            <Button
              fullWidth
              onClick={() => {
                auth.setSearchNetwork('Polygon')
                setOpenNetworkModal(false)
                auth.setNetworkcount(0)
              }}
            >
              Polygon
            </Button>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenNetworkModal(false)
              auth.setSearchToken('')
              auth.setIsLoadingSearchedData(0)
              auth.setIsSearchTrue(false)
              setNetworkName('')
            }}
            color="primary"
            style={{ color: '#5a86ff' }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        fullWidth
        maxWidth="sm"
        // onClose={() => setOpenNetworkModal(false)}
      >
        {/* <DialogTitle id="alert-dialog-title">{'Hi!'}</DialogTitle> */}
        <DialogContent>
          <Box textAlign="center">
            <img
              src="images/logo/logo-shape.svg"
              alt=""
              style={{ width: '80px', marginBottom: '16px' }}
            />
          </Box>
          <Typography variant="h4">
            {`Our team is working on ${networkName} network. We will catering soon!!`}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false)
              auth.setSearchToken('')
              auth.setIsLoadingSearchedData(0)
              auth.setIsSearchTrue(false)
              auth.setIsETHPolygon(false)
            }}
            variant="contained"
            size="large"
            color="primary"
            style={{ backgroundColor: 'rgb(90 134 255)' }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Head
